import React from "react";
import { Space } from "antd";
import { InteractionMods } from "@blings/blings-player";
import { ModsPanelCompProps } from "../../ModsPanel";
import { observer } from "mobx-react-lite";
import { LayerSelector } from "../../../LayerSelector";

interface Props<T> extends ModsPanelCompProps<T> {
  renderSpecificInteractive: (props: ModsPanelCompProps<T>) => React.ReactNode;
}
function _AddInteractiveHOC<T extends InteractionMods>(props: Props<T>) {
  const { change } = props;
  return (
    <Space direction={"vertical"} size={12} style={{ width: "100%" }}>
      <LayerSelector
        isMulti={true}
        placeholder="Select layers that will become interactive"
        assetLayerPairs={props.assetLayerPairs}
        selectedAssetId={change.assetId}
        selectedLayerName={change.layerName}
        selectedLayerUid={change.layerUid}
        selectedAdditionals={change.additionals}
        onChange={props.onLayerChange}
        jsonVid={props.json}
        index={props.index}
      />
      {/*
      // for now this option is hidden
      <Select
        placeholder="Select an event"
        showArrow
        style={{ width: "100%" }}
        onChange={(v) => {
          props.onChange(props.index, "event", v);
        }}
        options={[
          "onclick",
          "ondblclick",
          "onmouseover",
          "ondragend",
          "ondragstart",
          "ontouchend",
          "ontouchstart",
        ].map((e) => ({ label: e, value: e }))}
        value={change.event}
      />*/}
      {props.renderSpecificInteractive(props)}
    </Space>
  );
}
export const AddInteractiveHOC = observer(_AddInteractiveHOC);
